import styled, { css } from 'styled-components';

export const List = styled.ul<{ $lastItemBottomMargin?: string }>`
  list-style: disc;
  margin-top: 0;
  margin-bottom: 1rem;
  padding-left: 1.5rem;

  li {
    color: ${({ theme }) => theme.colors?.baseDarkGrey || theme.color?.ui?.grey?.[90] || 'inherit'};
    margin-bottom: 0.5rem;
    line-height: 1.5;

    &:last-child {
      margin-bottom: ${({ $lastItemBottomMargin }) => $lastItemBottomMargin || '0.5rem'};
    }
     p {
      margin: 8px 0;
     }
  }
`;

export const BenefitsLink = styled.a`
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
  width: fit-content;
  gap: 6px;
  margin-bottom: 24px;
  text-decoration: none;
  color: ${({ theme }) => theme.color.ui.blue[70]};
  font-weight: 500;
  svg {
    width: 20px;
    height: 20px;
  }

  &:hover {
    text-decoration: underline;
  }

  @media (max-width: 767px) {
    padding-top: 8px;
  }
`;

export const BenefitsLinkText = styled.span`
  color: ${({ theme }) => theme.color.ui.blue[70]};
  font-size: 16px;
  line-height: 20px;
  font-weight: 500;
  cursor: pointer;
  transition: text-decoration 0.2s ease;

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    box-shadow: ${({ theme }) => theme.focus?.shadow || '0 0 0 2px rgba(37, 90, 240, 0.5)'};
    outline: none;
  }
`;
